import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-286b19c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fd-header" }
const _hoisted_2 = { class: "fd-header-tp-box fd-header-tp-pd" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-header-x" }, null, -1))
const _hoisted_4 = { class: "company-header-name" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 关注 ")
const _hoisted_6 = { class: "fd-header-tp-box-reg" }
const _hoisted_7 = { class: "el-dropdown-link" }
const _hoisted_8 = { style: {"color":"#FFFFFF"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("财务管理")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("会员中心")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("退出登录")
const _hoisted_12 = {
  key: 2,
  class: "fd-header-tp-box-x"
}
const _hoisted_13 = {
  key: 0,
  style: {"font-size":"12px","background-color":"#fff","color":"#db7c12"}
}
const _hoisted_14 = { class: "fd-center fd-header-bt-box" }

import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ArrowDown, Avatar } from '@element-plus/icons-vue'
import Property from '@/views/middleGround/member/property.vue'
import CommunityBusinesses from '@/views/middleGround/member/communityBusinesses.vue'
import BrandManufacturers from '@/views/middleGround/member/brandManufacturers.vue'
import { defineComponent } from "vue";
import { shallowReactive } from "vue";

interface Company {
  type: number;
  code: string;
  name: string;
  shortName: string;
  licenseNo: string;
  licenseFile: string;
  logo: string;
  brandLogo: string;
  brandBigLogo: string;
  brandName: string;
  contact: string;
  mobile: string;
  tel: string;
  companyAreaIds: string;
  companyAreaIdList: string[];
  companyFace: string;
  remark: string;
  website: string;
  province: string;
  city: string;
  area: string;
  address: string;
  corporateRepresentative: string;
  registeredFund: number;
  industry: string;
  businessCategory: string;
  teamSize: number;
  handbagCertificateLevel: string;
  storefront: string;
  licenseFileFullPath: string;
  logoFullPath: string;
  brandBigLogoFullPath: string;
  brandLogoFullPath: string;
  areaId: string;
  isPublic: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const company: Company = {
  type: 2,
  code: "",
  name: "",
  shortName: "",
  licenseNo: "",
  licenseFile: "",
  logo: "",
  brandLogo: "",
  brandBigLogo: "",
  brandName: "",
  contact: "",
  mobile: "",
  tel: "",
  companyAreaIds: "",
  companyAreaIdList: [],
  companyFace: "",
  remark: "",
  website: "",
  province: "",
  city: "",
  area: "",
  address: "",
  corporateRepresentative: "",
  registeredFund: 0,
  industry: "",
  businessCategory: "",
  teamSize: 0,
  handbagCertificateLevel: "",
  storefront: "",
  licenseFileFullPath: "",
  logoFullPath: "",
  brandBigLogoFullPath: "",
  brandLogoFullPath: "",
  areaId: "",
  isPublic: "",
};

const ustore = useStore();
var bindData = shallowReactive({
  loginMember: ustore.state.loginMember == undefined ? {} : ustore.state.loginMember,
  isLogin: ustore.state.loginMember == undefined ? false : true,
  companyInfo: company
});
if (ustore.state.loginMember == undefined) {
  store.dispatch("getMyInfo").then(
    (data) => {
      //成功
      bindData.loginMember = data.result;
      bindData.isLogin = ustore.state.loginMember == undefined ? false : true
    },
    (error) => {
      console.log("获取当前登录会员信息错误");
    }
  );
}

const handleLogin = () => {
  router.push('/frontDesk/login')
}
//打开新页面
const openNewWindow = (path: any) => {
  const { href } = router.resolve({
    path: path
  });
  window.open(href, "_blank");
}
const gotoMemberCenterEvent = () => {
  openNewWindow('/middleGround/member/index')
}

const gotoMembershipFeesEvent = () => {
  openNewWindow('/middleGround/member/membershipFees');
}

const logoutEvent = () => {
  store.dispatch("memberLogout").then(
    (data) => {
      //成功
      router.push('/frontDesk/login')
    },
    (error) => {
      console.log(error.msg);
    }
  );
}

var id = router.currentRoute.value.params.id;

const tabs = reactive([
  {
    title: '回首页',
    name: 0,
    path: '/frontDesk/index'
  },
  {
    title: '企业首页',
    name: 1,
    path: '/company/CompanyIndex/' + id
  },
  {
    title: '楼盘招商',
    name: 2,
    path: '/company/invest/' + id
  },
  {
    title: '社区营销',
    name: 3,
    path: '/company/bbs/' + id
  },
  {
    title: '样板房',
    name: 4,
    path: '/company/room/' + id
  },
  {
    title: '企业信息',
    name: 5,
    path: '/company/detail/' + id
  },
]);

const activeIndex = ref(0)
const handleTabsToggle = () => {
  router.push(tabs[activeIndex.value].path)
}

const currPath = router.currentRoute.value.path;
const currIndex = tabs.findIndex((tab: any) => {
  return tab.path.length > 0 && currPath.startsWith(tab.path);
});

if (currIndex >= 0) {
  activeIndex.value = currIndex;
}

const handleToRegister = () => {
  router.push('/frontDesk/register/all')
}

const loadData = () => {
  store.dispatch("frontCompanyModule/getCompany", { companyCode: id }).then(
    (data) => {
      //成功
      bindData.companyInfo = data.result;
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => { },
      });
    }
  );
};

loadData();


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "fd-header-tp" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_container, { class: "company-header-hd" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_image, {
                fit: "fill",
                class: "company-header-logo1",
                src: require('@/assets/fd/company/u684.png')
              }, null, 8, ["src"]),
              _hoisted_3,
              _createVNode(_component_el_image, {
                fit: "fill",
                class: "company-header-logo2",
                src: _unref(bindData).companyInfo.brandLogoFullPath
              }, null, 8, ["src"]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(bindData).companyInfo.name), 1),
                _createVNode(_component_el_container, { class: "company-header-collect" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, {
                      fit: "fill",
                      class: "company-header-collect-icon",
                      src: require('@/assets/fd/company/u1493.png')
                    }, null, 8, ["src"]),
                    _hoisted_5
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            (!_unref(bindData).isLogin || _unref(tool).isNull(_unref(bindData).loginMember.avatarUrl))
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  class: "fd-header-tp-box-avatar"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Avatar), {
                      color: "#015d87",
                      size: 30
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(bindData).isLogin && _unref(tool).isNotNull(_unref(bindData).loginMember.avatarUrl))
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 1,
                  class: "fd-header-tp-box-icon",
                  src: _unref(bindData).loginMember.avatarUrl
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                (_unref(bindData).isLogin)
                  ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            (_unref(bindData).loginMember.month<=2)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 0,
                                  onClick: gotoMembershipFeesEvent
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_dropdown_item, { onClick: gotoMemberCenterEvent }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              divided: "",
                              onClick: logoutEvent
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(bindData).loginMember.name), 1),
                          _createVNode(_component_el_icon, {
                            class: "el-icon--right",
                            style: {"color":"#FFFFFF"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowDown))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(bindData).isLogin)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: handleLogin
                    }, "登录"))
                  : _createCommentVNode("", true),
                (!_unref(bindData).isLogin)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "|"))
                  : _createCommentVNode("", true),
                (!_unref(bindData).isLogin)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      onClick: handleToRegister
                    }, "注册"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("tr", null, [
                (_unref(bindData).isLogin && _unref(bindData).loginMember.month<=2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, "请及时缴纳会员费"))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_container, { class: "fd-header-bt" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_tabs, {
            modelValue: activeIndex.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeIndex).value = $event)),
            onTabClick: handleTabsToggle
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: item.name,
                  label: item.title,
                  name: item.name
                }, null, 8, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})